<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

      <div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>

        <p v-else-if="views.length == 0" class="pt-3 text-center">No views</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table">
          <tbody>
            <tr v-for="(view, index) in views" :key="index.id">
              
              <td class="pl-3">
                <a :href="'http://ip-api.com/json/'+view.ip" target="_blank" class="iplink">{{view.ip}}</a>
              </td>
              <td class="agent"><span :title="view.agent"><i :class="`${getAgentLogo(view.agent)} fa-2x logo`"></i></span></td>
              <td class="pl-3">{{view.city}}</td>
              <td class="pr-4">
                <img :src="'/images/flags/svg/'+getFlag(view.country)" class="country_flag" :title="view.country">
              </td>
              <td class="text-nowrap"><timeago
                  :datetime="view.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(view.created_at)"></timeago></td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">IP • Country • Date</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(view, index) in views" :key="index">
  
        <td class="pl-2">
            <div>{{ view.ip }}</div>
            <div>{{ view.country }}</div>
            <div><timeago
                  :datetime="view.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(view.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>

export default {
    props : ['advert_id'],
  data() {
    return {
      views: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getViews();

    // Echo.private("views")
    //   .listen("NewView", (event) => {
    //     this.getViews();
    //   });
  },

  methods: {
    getViews() {
      
      this.loading = true;

      axios.post('/adverts/views', {advert_id: this.advert_id}).
      then((response) => {
        this.views = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
a.iplink { font-weight:normal !important; }
.logo { position: relative; top: 0px;}
td.agent { text-align: center; width:70px; }
td.source { text-align: center; width:60px; }
</style>